export function createPageUrl(pageName: string) {
    const canonicalPages: Record<string, string> = {
        Home: '/',
        Projects: '/projects',
        RequestAQuote: '/request-a-quote',
        Services: '/services',
        PrivacyPolicy: '/privacy-policy',
        TermsAndConditions: '/terms-and-conditions',
    };
    if (canonicalPages[pageName]) return canonicalPages[pageName];
    return '/' + pageName.replace(/ /g, '-');
}
